import React, { useEffect, useState, useMemo } from "react";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import phoneNumberInput from "./PhoneNumberInput";
import PropTypes from "prop-types";
import { TextField } from '@totalsoft/rocket-ui';
import "react-phone-number-input/style.css";
import { styled } from '@mui/material';

const PhoneNumberTextField = props => {
    const { defaultCountry, country, value, onChange, onCountryChange, inputComponent, ...rest } = props;
    const [localValue, setLocalValue] = useState();
    const [localCountry, setLocalCountry] = useState(country);
    const [localInitialValueFormat, setLocalInitialValueFormat] = useState(null);

    useEffect(() => {
        if (value) {
            let phoneNumber = parsePhoneNumber(value);
            if (!phoneNumber) {
                phoneNumber = parsePhoneNumber(value, defaultCountry);
            }

            if (phoneNumber) {
                setLocalValue(phoneNumber.number);
                if (defaultCountry && phoneNumber.country === defaultCountry) setLocalInitialValueFormat("national");
                else setLocalInitialValueFormat(null);
            }
        } else {
            setLocalValue(value);
        }
    }, [value, defaultCountry]);

    useEffect(() => {
        setLocalCountry(country);
    }, [country]);

    const onChangeLocal = newValue => {
        if (newValue) {
            const phoneNumber = parsePhoneNumber(newValue);
            if (phoneNumber && phoneNumber.country === defaultCountry) {
                const nationalPhoneNumber = phoneNumber.formatNational().replace(/\D/g, "");
                onChange(nationalPhoneNumber);
            } else onChange(newValue);
        } else onChange(newValue);
    };

    const customInputComponent = useMemo(
        () => phoneNumberInput(inputComponent ? inputComponent : TextField),
        [inputComponent]
    );

    const onCountryChangeLocal = selectedCountry => {
        setLocalCountry(selectedCountry);
        if (onCountryChange) onCountryChange(selectedCountry);
    };

    return (
        <StyledPhoneInput
            defaultCountry={localCountry ? localCountry : defaultCountry}
            value={localValue}
            onChange={onChangeLocal}
            onCountryChange={onCountryChangeLocal}
            initialValueFormat={localInitialValueFormat}
            error={rest.error}
            inputComponent={customInputComponent}
            {...rest}
        />
    );
};

PhoneNumberTextField.propTypes = {
    defaultCountry: PropTypes.string,
    country: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onCountryChange: PropTypes.func,
    value: PropTypes.any.isRequired,
    inputComponent: PropTypes.elementType
};

const StyledPhoneInput = styled(PhoneInput)(({ theme, error }) => ({
    '& .PhoneInputCountrySelect': {
        backgroundColor: theme.palette.text.white,
        color: 'rgb(0, 0, 0, 0.87)'
    },
    '& .PhoneInputCountrySelect option': {
        fontSize: '1rem'
    },
    '& .PhoneInputCountry': {
        alignItems: 'end',
        paddingBottom: theme.spacing(1),
        paddingRight: theme.spacing(0.5)
    },
    '& .PhoneInputCountrySelectArrow': {
        display: 'none'
    },
    ...(error && {
        '& .PhoneInputCountry': {
            alignItems: 'center'
        }
    })
}))


export default PhoneNumberTextField;
